const constants = Object.freeze({
  // baseUrl: "https://giving-art-production.up.railway.app/api",
  // baseUrl: "https://awaken-server-production-f178.up.railway.app/api",
  // baseUrl: "https://hr-bot-nodejs-server-production.up.railway.app/api",
  // testUrl: "https://hr-bot-nodejs-server-production.up.railway.app/api",
  // baseUrl: "https://awaken-a9dha5fzg7fybwde.centralindia-01.azurewebsites.net/api",
  baseUrl: "https://awakenserver2.azurewebsites.net/api",
  // baseUrl: "http://localhost:4000/api",
  // baseUrl: "http://localhost:4000/api",
  formUrl: "https://awaken.mainstream.co.in",
  factFinderBaseUrl: "https://ffapi.mainstream.co.in/api",
  // formUrl: process.env.REACT_APP_FORM_APP_URL || "http://localhost:5173",
  // baseUrl: process.env.REACT_APP_API_URL || "http://localhost:4000/api",
  isTestServer: false,
});

export default constants;
